<xi-side-panel
  panelWidth="444px"
  closedPanelWidth="61px"
  [open]="panelOpen()"
  (onClose)="isInterceptEnabled() ? $event.stopPropagation() : onPanelClose()"
  (onOpen)="isInterceptEnabled() ? $event.stopPropagation() : onPanelOpen()"
  [interceptOpen]="isInterceptEnabled() || !activeTab()?.leftSideTemplate"
  [interceptClose]="isInterceptEnabled() || !activeTab()?.leftSideTemplate"
>
  <div slot="side-panel" class="lex-xi-side-panel__left-side">
    @if (isLoading() && panelOpen()) {
      <div class="xi-loader-container__center">
        <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
      </div>
    }
    @if (!isLoading()) {
      <div class="lex-xi-side-panel__vertical-tab-bar-container">
        <xi-vertical-tab-bar
          color="CX"
          [data]="filteredTabBarData()"
          [activeTabId]="activeTab()?.id"
          (onTabChange)="onTabChange($event)"
        ></xi-vertical-tab-bar>
      </div>
    }
    <div class="lex-xi-side-panel__left-side-content-container">
      @if (!isLoading() && panelOpen()) {
        <ng-container *ngTemplateOutlet="activeTab()?.leftSideTemplate"></ng-container>
      }
    </div>
  </div>

  <div
    slot="main-content"
    [ngClass]="
      panelOpen()
        ? 'lex-xi-side-panel__main-content--panel-open'
        : 'lex-xi-side-panel__main-content--panel-closed'
    "
  >
    @if (selectedItem() || !rightPlaceholder()) {
      <ng-container *ngTemplateOutlet="activeTab()?.rightSideTemplate"></ng-container>
    } @else {
      @if (!isLoading()) {
        <div class="lex-xi-side-panel__main-content-placeholder">
          <div class="lex-xi-side-panel__no-results-icon"><xi-svg svg="none"></xi-svg></div>
          <div class="lex-xi-side-panel__main-content-placeholder-title">
            {{ rightPlaceholder().title }}
          </div>
          <div class="lex-xi-side-panel__main-content-placeholder-subtitle">
            {{ rightPlaceholder().subtitle }}
          </div>
        </div>
      }
      @if (isLoading()) {
        <div class="xi-loader-container__center">
          <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
        </div>
      }
    }
  </div>
</xi-side-panel>

@if ((rtrConnected$ | async) === false) {
  <div class="rtr-indicator">
    <xi-icon icon="asterisk" iconSize="large" color="grey_light_70"></xi-icon>
  </div>
}
